import { createApp } from "vue";
import App from "./App.vue";
import "./assets/css/index.css";
import ElementPlus from "element-plus";
import "element-plus/lib/theme-chalk/index.css";
import locale from "element-plus/lib/locale/lang/zh-cn";
import api from "./http/api";
import http from "./http/http";
import "./http/axios";
import { checkPlatform, parseQuery } from "./utils/common";
import router from "./router/index";

const app = createApp(App);
app.use(router)
app.use(ElementPlus, { locale })
app.config.globalProperties.checkPlatform = checkPlatform
app.config.globalProperties.parseQuery = parseQuery
app.config.globalProperties.$api = api
app.config.globalProperties.$http = http
app.mount("#app");
